import React, { ChangeEvent, useEffect, useState } from "react";
import TeamTabContentStyles from "./RoleTabContent.styles";
import { Box, Chip, Grid, InputAdornment, Link } from "@mui/material";
import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import CustomInput from "../../../../global/components/CustomInput/CustomInput";
import { debounceEventHandler, isTruthy, openErrorNotification } from "../../../../helpers/methods";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/close.svg";
import strings from "../../../../global/constants/StringConstants";
import SearchIcon from "@mui/icons-material/Search";
import CustomTable from "../../../../global/components/CustomTable/CustomTable";
import { TeamHeader } from "./RoleTabContentData";
import customErrorHandler from "../../../../utils/customErrorHandler";
import notifiers from "../../../../global/constants/NotificationConstants";
import history from "../../../../utils/history";
import urls from "../../../../global/constants/UrlConstants";
import AddRole from './AddRole/Role';
import { findUserLoanList } from "./AddRole/roleService";
import CustomDialog from "../../../../global/components/CustomModal/CustomModal";

interface CustomProps {
  isDialogOpenLoan: boolean;
  handleCloseLoan: Function;
  userId: string;
  status: any;
}

const TeamTabContent = (props: CustomProps) => {
  const classes = TeamTabContentStyles;
  const [search, setSearch] = useState<string>("");
  const [userDataSource, setUserDataSource] = useState<any>([]);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [count, setCount] = useState<number>(5);
  const [idd, setIdd] = useState<string>("");
  const [getAddTeamMetaDataDylog, setGetAddTeamMetaDataDylog] = useState<boolean>(false);

  useEffect(() => {
    init();
  }, []);

  const handleEdit = (id: string) => {
    setIdd(id);
    setGetAddTeamMetaDataDylog(true);
  }

  const preventDefault = (event: React.SyntheticEvent) => event.preventDefault();

  const init = async () => {
    try {
      const response = await findUserLoanList(props.userId);
      if (response?.data.length > 0) {
        response.data = response.data.map((e: any) => {
          return {
            loan_acc: e.loan_acc, loan_amt: e.loan_amt, loan_emi: e.loan_emi, start_from: e.start_from, updated_amt: e.updated_amt, action: <Box
              sx={{
                typography: 'body1',
                '& > :not(style) ~ :not(style)': {
                  ml: 2,
                },
              }}
              onClick={preventDefault}
            >
              <Link
                component="button"
                variant="body2"
                onClick={() => handleEdit(e._id)}
              >
                Edit
              </Link>
            </Box>, id: e._id
          };
        });
        customErrorHandler(response);
        setUserDataSource(response.data);
      }
    } catch (error: any) {
      openErrorNotification(isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR);
    }
  };

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };

  const handleCloseAddTeamMetaData = () => {
    init();
    setGetAddTeamMetaDataDylog(false);
  };

  const handleRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // get value from Input field
  const handleSearchOnChange = async (SearchEvent: ChangeEvent<HTMLInputElement>) => {
    if (SearchEvent.target.value) {
      setSearch(SearchEvent.target.value.replace(/\s/g, ""));
    } else {
      setSearch("");
    }
  };

  const onClickHandle = () => {
    setIdd("");
    setGetAddTeamMetaDataDylog(true);
  };

  const dialogHeaderContentLoan = () => {
    return (
      <Box marginTop={1} marginRight={3} sx={{ cursor: "pointer" }}>
        <CloseIcon onClick={() => props.handleCloseLoan()} />
      </Box>
    );
  };

  const dialogTitleContentLoan = () => {
    return (
      <>
        <Box sx={classes.teamTabContentWrapper}>
          <Grid container>
            <Grid item xs={12}>
              <Grid container columnSpacing={5}>
                <Grid item xs={10}>

                </Grid>
                <Grid item xs={2}>
                  <CustomButton buttonType='primaryBtn' label='Add loan' onClick={() => onClickHandle()} />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <CustomTable
                headers={TeamHeader}
                rows={userDataSource}
                size={[5]}
                handlePageChange={handleChangePage}
                handleRowsPerPage={handleRowsPerPage}
                paginationCount={count}
                rowsPerPage={rowsPerPage}
                pageNumber={page}
              />
            </Grid>
          </Grid>
          <AddRole isDialogOpen={getAddTeamMetaDataDylog} handleCloseAddTeamMetaData={handleCloseAddTeamMetaData} idd={idd} setIdd={setIdd} userId={props.userId} />
        </Box>
      </>
    );
  };

  return (
    <>
      <CustomDialog
        fullScreen={true}
        isDialogOpen={props.isDialogOpenLoan}
        dialogHeaderContent={dialogHeaderContentLoan()}
        dialogTitleContent={dialogTitleContentLoan()}
        handleDialogClose={props.handleCloseLoan}
      />
    </>
  );
};

export default TeamTabContent;
